import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import colours from '../lib/colours'

const StyledFooter = styled.footer`
  background: ${colours.darkPurple};
  color: ${colours.white};
  padding: 15px 0;
`

const TextContainer = styled.div`
  font-size: 16px;
  font-weight: 300;
  margin-bottom: 16px;
  margin-top: 16px;
`

const Footer = (props: PropsWithChildren<{}>) => (
  <StyledFooter>
    <div className="container">
      <TextContainer>{props.children}</TextContainer>
    </div>
  </StyledFooter>
)

export default Footer
